import type { LoginResponse } from "@/lib/api/types";
import { applySessionRegion } from "@/lib/admin-region";
import { getApiBase } from "@/lib/env";
import { useAuthStore } from "@/stores/auth-store";

let inflight: Promise<boolean> | null = null;

/** Exchanges refresh token for a new access + refresh pair (server rotates refresh). */
export async function refreshAccessToken(): Promise<boolean> {
  const { refreshToken, rememberMe } = useAuthStore.getState();
  if (!refreshToken) return false;
  if (inflight) return inflight;

  inflight = (async (): Promise<boolean> => {
    try {
      const res = await fetch(`${getApiBase()}/admin/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken }),
      });
      if (!res.ok) return false;
      const data = (await res.json()) as LoginResponse;
      useAuthStore.getState().setSession({
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
        rememberMe,
      });
      applySessionRegion({ region: data.region, lockRegion: data.lockRegion });
      return true;
    } catch {
      return false;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
